import { render } from "./Button.vue?vue&type=template&id=afb94134"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "afb94134"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('afb94134', script)) {
    api.reload('afb94134', script)
  }
  
  module.hot.accept("./Button.vue?vue&type=template&id=afb94134", () => {
    api.rerender('afb94134', render)
  })

}

script.__file = "resources/js/Jetstream/Button.vue"

export default script